import React from "react";
import { useFirestoreAdmin } from "../context/FirestoreAdminProvider";
import { AdminRole, Permission, roleLabel } from "../access";

const ROLE_ROWS = [
  {
    role: AdminRole.administrator,
    permissions: Object.values(Permission),
  },
  {
    role: AdminRole.manager,
    permissions: [
      Permission.view,
      Permission.edit,
      Permission.export,
      Permission.query,
      Permission.analyzer,
      Permission.monitor,
      Permission.search,
    ],
  },
  {
    role: AdminRole.viewer,
    permissions: [Permission.view, Permission.export, Permission.monitor, Permission.search],
  },
];

export default function PermissionsPage() {
  const { user, adminRole, roleLabel: currentRole, can } = useFirestoreAdmin();

  return (
    <div className="fa-page">
      <header className="fa-page-header">
        <h1 className="fa-page-title">Permissions</h1>
        <p className="fa-page-subtitle">
          Role-based access for the Firestore Admin Console. Your role:{" "}
          <strong>{currentRole}</strong>
        </p>
      </header>

      <div className="fa-card p-4 mb-4">
        <p className="text-sm text-slate-600">
          Signed in as <strong>{user?.email || user?.username || "—"}</strong>. App role:{" "}
          <code className="rounded bg-slate-100 px-1">{user?.role || "viewer"}</code>
        </p>
      </div>

      <div className="grid gap-4 lg:grid-cols-3">
        {ROLE_ROWS.map((row) => (
          <div
            key={row.role}
            className={`fa-card p-4 ${adminRole === row.role ? "ring-2 ring-indigo-500" : ""}`}
          >
            <h2 className="text-lg font-semibold text-slate-800">{roleLabel(row.role)}</h2>
            <ul className="mt-3 space-y-1 text-sm text-slate-600">
              {row.permissions.map((p) => (
                <li key={p} className="flex items-center gap-2">
                  <span className="material-symbols-outlined text-[16px] text-emerald-600">
                    check_circle
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="fa-card mt-4 p-4">
        <h3 className="font-semibold text-slate-800">Your effective permissions</h3>
        <div className="mt-2 flex flex-wrap gap-2">
          {Object.values(Permission).map((p) => (
            <span
              key={p}
              className={`rounded-full px-3 py-1 text-xs font-medium ${
                can(p) ? "bg-emerald-100 text-emerald-800" : "bg-slate-100 text-slate-400"
              }`}
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
